import React from 'react';
import '../assets/ak-cached/24h/css/progressBar.css';
import { Line } from '@vds/lines';
import { TextLinkCaret } from '@vds/buttons';

class ProgressBar extends React.PureComponent {
    constructor(props){
        super(props);
        this.state={
            disableServicesText: true,
            disableCheckoutText : true,
            disablePlaceOrderText : true,

            disableServicesBar : true,
            disableCheckoutBar : true,
            disablePlaceOrderBar : true,

            enableCarretLeft : false,
            enableCarretRight : false,    
            
            partialEnableCheckoutBar : false,
            partialEnableBPBar : false,
            partialEnablePOBar : false
        }
    }

    leftCarretClick = (e) =>{
        if(this.props.inCheckoutPage)
            this.props.onBackBtnClick(true)
    }

    onCheckoutClick = () =>{
        if(this.props.inServicesPage && (!this.props.submitChanges && this.props.showSpecificErrorMessages===""))
            this.props.moveToCheckout()
    }

    onPlaceOrderClick = () =>{

    }

    rightCarretClick = () =>{

    }

    render() {
            if(this.props.inServicesPage){
                this.setState({
                    disableServicesText : false,
                    disableServicesBar : false,
                    disableCheckoutText : true,
                    disableCheckoutBar : true,
                    disablePlaceOrderText : true,
                    disablePlaceOrderBar : true
                })
                if(!this.props.submitChanges && !this.props.checkoutDisable && this.props.showSpecificErrorMessages===""){
                    this.setState({
                        disableServicesText : false,
                        disableServicesBar : false
                    })
                }
            }else if(this.props.inCheckoutPage){
                this.setState({
                    enableCarretLeft : true,
                    disableServicesText : true,
                    disableServicesBar : false,
                    partialEnableCheckoutBar : true,
                    disableCheckoutBar : false,
                    disableCheckoutText : false
                })
                if(this.props.showSpecificErr==="" && !this.props.placeOrderClicked){
                    this.setState({
                        disableCheckoutText : false,
                        disableCheckoutBar : false,
                        partialEnableCheckoutBar : true
                    })
                }
            }else if(this.props.inPlaceOrderPage){
                this.setState({
                    enableCarretLeft : false,
                    disableServicesText : true,
                    disableServicesBar : false,
                    disableCheckoutText : true,
                    disableCheckoutBar : false,
                    disablePlaceOrderText : false,
                    disablePlaceOrderBar : false,
                    partialEnableCheckoutBar : true
                })
            }


            return(<>
                <div className="background_div" style={{padding:this.props.inPlaceOrderPage ? !this.props.addPaddingforBar ? '1rem 0 2rem 0' : '10rem 0 2rem 0' : ''}}>
                    <div style={{paddingTop:'1rem'}}>
                        <div style={{display:'flex', marginLeft:'5%'}}>
                            <div style={{marginTop:'1rem'}}>
                                <TextLinkCaret 
                                    className="carret_enabled"
                                    style={{display:!this.state.enableCarretLeft && 'none'}}
                                    surface="light"  
                                    iconPosition="left"
                                    onClick={e => this.leftCarretClick(e)}>
                                </TextLinkCaret>
                            </div>
                            <div className='text_line' onClick={e => this.leftCarretClick(e)}>
                                <div style={{marginBottom:!this.props.inPlaceOrderPage ? '-1.5rem' : '0.5rem'}}>
                                    <p className={this.state.disableServicesText ? 'status_text_disabled' :'status_text_enabled'} style={{fontWeight:this.props.inServicesPage && 'bolder'}}>Services</p>
                                </div>
                                <div style={{display:'flex'}}>
                                    <Line
                                        className={this.state.disableServicesBar ? "status_bar_inprogress" :"status_bar_completed"}
                                        surface="light"/>
                                    <Line
                                        className={this.state.disableServicesBar ? "status_bar_inprogress" :"status_bar_completed"}
                                        surface="light"/>
                                </div>
                            </div>
                            <div className='text_line' onClick={e => this.onCheckoutClick()}>
                                <div style={{marginBottom:!this.props.inPlaceOrderPage ? '-1.5rem' : '0.5rem'}}>
                                    <p className={this.state.disableCheckoutText ? 'status_text_disabled' :'status_text_enabled'}>Checkout</p>
                                </div>
                                <div style={{display:'flex'}}>
                                    <Line
                                        className={!this.state.partialEnableCheckoutBar ? "status_bar_inprogress" :"status_bar_completed"}
                                        surface="light"/>
                                    <Line
                                        className={this.state.disableCheckoutBar ? "status_bar_inprogress" :"status_bar_completed"}
                                        surface="light"/>
                                </div>
                            </div>
                            <div className='text_line' onClick={e => this.onPlaceOrderClick()}>
                                <div style={{marginBottom:!this.props.inPlaceOrderPage ? '-1.5rem' : '0.5rem'}}>
                                    <p className={this.state.disablePlaceOrderText ? 'status_text_disabled' :'status_text_enabled'}>Place Order</p>
                                </div>
                                <div style={{display:'flex'}}>
                                    <Line
                                        className={this.state.disablePlaceOrderBar ? "status_bar_inprogress" :"status_bar_completed"}
                                        surface="light"/>
                                    <Line
                                        className={this.state.disablePlaceOrderBar ? "status_bar_inprogress" :"status_bar_completed"}
                                        surface="light"/>
                                </div>
                            </div>
                            <div style={{marginTop:'1rem'}}>
                                <TextLinkCaret 
                                    className="carret_enabled"
                                    style={{display:!this.state.enableCarretRight && 'none'}}
                                    surface="light"  
                                    iconPosition="right"
                                    onClick={e => this.rightCarretClick()}>
                                </TextLinkCaret>
                            </div>
                        </div>
                    </div>
                </div>
            </>)
    }
}

export default ProgressBar

